'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024 from "./presto.-Edit-Group-Site-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457 from "./presto.-Presto-Router$$anon$57.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$56() {
  this.bkp = null;
  this.bkh = null;
  this.bki = false;
  this.bkq = null;
  this.bkr = false;
  this.bku = null;
  this.bkn = null;
  this.bko = false;
  this.bkj = null;
  this.bkk = false;
  this.bkl = null;
  this.bkm = false;
  this.bks = false;
  this.bkt = false;
  this.bkp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bku = "EditGroupSitePage";
}
export { $c_Lpresto_PrestoRouter$$anon$56 as $c_Lpresto_PrestoRouter$$anon$56 };
$p = $c_Lpresto_PrestoRouter$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$56;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$56() {
}
export { $h_Lpresto_PrestoRouter$$anon$56 as $h_Lpresto_PrestoRouter$$anon$56 };
$h_Lpresto_PrestoRouter$$anon$56.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bkp;
});
$p.L = (function() {
  if ((!this.bki)) {
    this.bkh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bki = true;
  }
  return this.bkh;
});
$p.O = (function() {
  if ((!this.bkr)) {
    this.bkq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkr = true;
  }
  return this.bkq;
});
$p.E = (function() {
  return this.bku;
});
$p.t = (function() {
  if ((!this.bko)) {
    this.bkn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bko = true;
  }
  return this.bkn;
});
$p.M = (function() {
  if ((!this.bkk)) {
    this.bkj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().me(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bkk = true;
  }
  return this.bkj;
});
$p.Q = (function() {
  if ((!this.bkm)) {
    this.bkl = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457.$c_Lpresto_PrestoRouter$$anon$57();
    this.bkm = true;
  }
  return this.bkl;
});
$p.w = (function() {
  if ((!this.bkt)) {
    this.bks = false;
    this.bkt = true;
  }
  return this.bks;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee427) => ((p) => \u03b4scrutinee427.cG4(p)))($j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024.$m_Lpresto_EditGroupSitePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$56, "presto.PrestoRouter$$anon$56", ({
  Oo: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$56 as $d_Lpresto_PrestoRouter$$anon$56 };
//# sourceMappingURL=presto.-Presto-Router$$anon$56.js.map
